import type { ReactElement } from 'react';
import { cn } from '@xdocs/ui';
import { SettingsNav } from '../SettingsNav.js';
import { BuyCreditsGrid } from './BuyCreditsGrid.js';
import { CreditsSection } from './CreditsSection.js';
import { InvoicesTable } from './InvoicesTable.js';
import { PlanCard } from './PlanCard.js';
import { useSubscription } from './useSubscription.js';
import { useSettingsBillingT } from './useSettingsBillingT.js';
import styles from './BillingPage.module.css';

/**
 * `/settings/billing` (F19/F20/F24/F26/F45/F46/F56/F57): plan card + cancel
 * flow, credits balance + ledger, buy-credits packs grid + promo, invoices.
 */
export function BillingPage(): ReactElement {
  const { t } = useSettingsBillingT();
  const { subscription } = useSubscription();
  const isPro = subscription !== null && subscription !== undefined && (subscription.status === 'active' || subscription.status === 'trialing');

  return (
    <div className={cn(styles['page'])}>
      <div className={cn(styles['header'])}>
        <h1 className={cn(styles['title'])}>{t('settingsBilling:page.title')}</h1>
        <p className={cn(styles['description'])}>{t('settingsBilling:page.description')}</p>
      </div>

      <SettingsNav />

      <PlanCard />
      <CreditsSection />
      <BuyCreditsGrid />
      <InvoicesTable isPro={isPro} />
    </div>
  );
}
